import React from 'react'
import PropTypes from 'prop-types'

const BulletText = ({ color, text }) => {
    const classFromColor = {
        blue: 'info-bg',
        green: 'success-bg',
        red: 'alert-bg',
    }
    const colorClass = classFromColor[color]
    const colorClassPart = colorClass ? colorClass + ' ' : ''
    return (
        <span className="inline-block padding-left-tiny uppercase text-xxsmall font-bold dark-gray-color">
            <span className={colorClassPart + 'bullet'} />
            {text}
        </span>
    )
}

BulletText.propTypes = {
    color: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
}

export const BlueBulletText = ({ text }) => (
    <BulletText color="blue" text={text} />
)

BlueBulletText.propTypes = {
    text: PropTypes.string.isRequired,
}

export const GreenBulletText = ({ text }) => (
    <BulletText color="green" text={text} />
)

GreenBulletText.propTypes = {
    text: PropTypes.string.isRequired,
}

export const RedBulletText = ({ text }) => (
    <BulletText color="red" text={text} />
)

RedBulletText.propTypes = {
    text: PropTypes.string.isRequired,
}
